import EzController from 'controllers/ez-base-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class PinterestShareController extends EzController {
  connect() {
    this.flagLoaded();
  }

  shareClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const { target } = event;

    const { pinType } = target.dataset;

    const pin = {
      url: target.dataset.url,
      media: target.dataset.media,
      description: target.dataset.desc,
    };

    triggerCustomEvent(events.social.pinterest_share, { pinType });

    window.PinUtils.pinOne(pin);
  }
}
